import { render } from "./auth-layout.vue?vue&type=template&id=4fb45da7"
import script from "./auth-layout.vue?vue&type=script&lang=js"
export * from "./auth-layout.vue?vue&type=script&lang=js"

import "./auth-layout.vue?vue&type=style&index=0&id=4fb45da7&lang=scss"
import "./auth-layout.vue?vue&type=style&index=1&id=4fb45da7&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__